<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
  formGroupName="houseFormGroup"
>
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="form-group-title my-1" translate>LEAD_FIELDSET_HOUSE</div>
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_HOUSING_TYPE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceHousingType'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseHousingType'
                )
              "
            />
          </div>
        </div>
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >LEAD_LBL_HOUSE_FLAT_LEVEL</label
            >
            <div class="col">
              <app-typeahead
                [limitToList]="true"
                [dropdownStyle]="DropdownStyle.DropDown"
                [dataType]="DataType.Enum"
                [referenceEndpoint]="'Views/enum/values'"
                [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceFlatLevel'
              "
                [valueMember]="'value'"
                [displayMember]="'name'"
                [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseFlatLevel'
                )"
              />
            </div>
          </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_NUMBER_ROOMS</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              id="houseNbOfRooms"
              name="houseNbOfRooms"
              type="number"
              min="1"
              max="12"
              formControlName="houseNbOfRooms"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_AMOUNT_INSURE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceAmountToInsure'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseAmountToInsure'
                )"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_ADDRESS</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              id="houseAddress"
              name="houseAddress"
              type="text"
              formControlName="houseAddress"
              checkFormFieldValidity
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-4 col-form-label-sm"> </label>
          <div class="col-2">
            <input
              class="form-control form-control-sm"
              id="houseZipCode"
              name="houseZipCode"
              type="text"
              placeholder="{{ 'LEAD_PLACEHOLDER_ZIPCODE' | translate }}"
              formControlName="houseZipCode"
              checkFormFieldValidity
              mask="00000"
              maxlength="5"
            />
          </div>
          <div class="col">
            <app-typeahead
              [entity]="Entity.ZipCode"
              [referenceEndpoint]="'ZipCodes/Cities/'"
              [dropdownStyle]="DropdownStyle.DropDown"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get('houseCity')
              "
              [limitToList]="true"
              [referenceFilterParentName]="'Code'"
              [referenceFilterParentValue]="
                this.leadForm.controls['houseFormGroup'].get('houseZipCode')
                  ?.value
              "
              [valueMember]="'name'"
              [displayMember]="'name'"
              [dbNameOfId]="'City'"
              [dbNameOfName]="'City'"
              [referenceField]="'City'"
              [showFirstElement]="true"
            ></app-typeahead>
          </div>
        </div>


      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_RESIDENCY_TYPE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceResidencyType'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseResidencyType'
                )"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_AREA</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              id="houseArea"
              name="houseArea"
              type="number"
              min="1"
              max="350"
              formControlName="houseArea"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_CONSTRUCTION_TYPE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceConstructionType'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseConstructionType'
                )"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_ROOF_TYPE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceRoofType'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseRoofType'
                )"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="form-group-title my-1" translate>LEAD_FIELDSET_OCCUPANT</div>
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_OCCUPANCY_ROLE</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.HouseInsuranceOccupancyRole'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseOccupancyRole'
                )"
            />
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_CURRENT_INSURANCE_COMPANY</label
          >
          <div class="col">
            <app-typeahead
              [limitToList]="true"
              [dropdownStyle]="DropdownStyle.DropDown"
              [dataType]="DataType.Enum"
              [referenceEndpoint]="'Views/enum/values'"
              [referenceField]="
                'Comparanoo.Core.Enums.Comparanoo.InsuranceCurrentInsuranceCompany'
              "
              [valueMember]="'value'"
              [displayMember]="'name'"
              [controlForm]="
                this.leadForm.controls['houseFormGroup'].get(
                  'houseCurrentInsuranceCompany'
                )"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="form-group-title my-1" translate>
        LEAD_FIELDSET_HOUSE_NEED
      </div>
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_FIRE_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseFireCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_WATER_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseWaterCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_THEFT_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseTheftCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_GLASS_BREAK_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseGlassBreakCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_PUBLIC_LIABILITY_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="housePublicLiabilityCoverage"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_FEE_CANCELLATION_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseFeeCancellationCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_POOL_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="housePoolCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_DOG_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseDogCoverage"
              />
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >LEAD_LBL_HOUSE_ELECTRICAL_DAMAGE_COVERAGE</label
          >
          <div class="col">
            <span class="form-control-plaintext form-control-sm">
              <input
                type="checkbox"
                name="active"
                formControlName="houseElectricalDamageCoverage"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
